export default function Footer() {
  return (
    <footer
      className="bg-eje text-white/80 mt-24"
      data-testid="site-footer"
    >
      <div className="container-wide py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <h3 className="font-serif text-2xl text-white mb-3">
            Escuela Judicial Electoral
          </h3>
          <p className="text-sm leading-relaxed text-white/70 max-w-sm">
            Tribunal Electoral del Poder Judicial de la Federación. Programa de
            Posdoctorado y Estancias de Investigación 2026.
          </p>
        </div>
        <div>
          <div className="overline text-white/60 mb-3">Contacto</div>
          <ul className="text-sm space-y-1.5 text-white/80">
            <li>
              <a
                href="mailto:pei.eje@te.gob.mx"
                className="hover:text-gold transition-colors"
                data-testid="footer-email-link"
              >
                pei.eje@te.gob.mx
              </a>
            </li>
            <li>
              <a
                href="https://www.te.gob.mx/eje/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-gold transition-colors"
                data-testid="footer-site-link"
              >
                www.te.gob.mx/eje/
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/60 mb-3">Avisos</div>
          <p className="text-xs text-white/60 leading-relaxed mb-3">
            Esta plataforma constituye un medio oficial de inscripción para la
            convocatoria 2026. La información proporcionada será tratada conforme
            a la normatividad aplicable en materia de datos personales.
          </p>
          <a
            href="/aviso-privacidad"
            className="text-xs text-gold hover:underline"
            data-testid="footer-aviso-link"
          >
            Aviso de privacidad →
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © 2026 Escuela Judicial Electoral · TEPJF
      </div>
    </footer>
  );
}
